<script setup lang="ts">
import InputText from 'primevue/inputtext'

withDefaults(
  defineProps<{
    type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url' | 'search'
    placeholder?: string
    invalid?: boolean
    disabled?: boolean
    readonly?: boolean
    id?: string
    name?: string
    autocomplete?: string
    maxlength?: number
    size?: 'small' | 'large'
  }>(),
  {
    type: 'text',
    placeholder: '',
    invalid: false,
    disabled: false,
    readonly: false,
    id: undefined,
    name: undefined,
    autocomplete: undefined,
    maxlength: undefined,
    size: undefined,
  },
)

const model = defineModel<string | null | undefined>({ default: '' })
const emit = defineEmits<{ blur: [event: FocusEvent] }>()
</script>

<template>
  <InputText
    :id="id"
    v-model="model"
    :type="type"
    :placeholder="placeholder"
    :invalid="invalid"
    :disabled="disabled"
    :readonly="readonly"
    :input-id="id"
    :name="name"
    :autocomplete="autocomplete"
    :maxlength="maxlength"
    :size="size"
    fluid
    data-kit="input"
    @blur="emit('blur', $event)"
  />
</template>
